/**
 * SupposedBikePathLegend - Легенда этапов предлагаемых велодорожек
 *
 * Мигрирована на новую систему легенд (Этап 3)
 * Использует LegendRenderer с типом COLORED_ITEMS и иконкой LINE
 */

import { t } from '@lingui/macro';
import { LegendRenderer } from '../../LegendRenderer';
import { SUPPOSED_BIKE_PATH_LEGEND } from '../../../constants/legends';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';

const SupposedBikePathLegendComponent = () => (
    <LegendRenderer config={SUPPOSED_BIKE_PATH_LEGEND} />
);

export const SupposedBikePathLegend = withDisplayedLayersCheck(
    SupposedBikePathLegendComponent,
    t`Предлагаемые велодорожки`
);
